(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heartkey-category-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-hk-category-slider]';

    function getSliders(root) {
      const sliders = [];
      if (root instanceof Element && root.matches(SELECTOR)) sliders.push(root);
      if (root.querySelectorAll) sliders.push(...root.querySelectorAll(SELECTOR));
      return sliders;
    }

function initializeMobileAutoplay(slider) {
  const track = slider.querySelector('[data-hk-track]');
  const button = slider.querySelector('[data-hk-autoplay-toggle]');
  if (!track || !button) return;
  const slides = [...track.children];
  const mobile = window.matchMedia('(max-width: 749px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const controller = new AbortController();
  const options = { signal: controller.signal };
  const delay = Math.max(Number(slider.dataset.delay) || 5000, 2000);
  let timer = null;
  let visible = false;
  let paused = false;
  let touching = false;
  let hovering = false;
  let focused = slider.contains(document.activeElement);
  let destroyed = false;
  function stop() {
    window.clearTimeout(timer);
    timer = null;
  }
  function eligible() {
    return !destroyed && mobile.matches && !reduced.matches && visible && !document.hidden && !paused && !touching && !hovering && !focused && slides.length > 1 && track.scrollWidth > track.clientWidth + 2;
  }
  function sync() {
    stop();
    button.hidden = !mobile.matches || reduced.matches || slides.length < 2;
    button.textContent = paused ? button.dataset.resume : button.dataset.pause;
    if (eligible()) timer = window.setTimeout(advance, delay);
  }
  function advance() {
    timer = null;
    if (!eligible()) return;
    const position = track.scrollLeft;
    const max = track.scrollWidth - track.clientWidth;
    const trackLeft = track.getBoundingClientRect().left;
    const offsets = slides.map(slide => slide.getBoundingClientRect().left - trackLeft + position);
    let nearest = 0;
    offsets.forEach((offset, index) => {
      if (Math.abs(offset - position) < Math.abs(offsets[nearest] - position)) nearest = index;
    });
    const next = position >= max - 2 ? 0 : Math.min(max, offsets[Math.min(nearest + 1, slides.length - 1)]);
    track.scrollTo({ left: next, behavior: 'smooth' });
    sync();
  }
  const observer = new IntersectionObserver(entries => {
    visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.1);
    sync();
  }, { threshold: [0, 0.1] });
  observer.observe(track);
  button.addEventListener('click', () => { paused = !paused; sync(); }, options);
  slider.addEventListener('focusin', () => { focused = true; sync(); }, options);
  slider.addEventListener('focusout', event => { focused = slider.contains(event.relatedTarget); sync(); }, options);
  slider.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; sync(); } }, options);
  slider.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovering = false; sync(); } }, options);
  slider.addEventListener('pointerdown', () => { touching = true; sync(); }, options);
  const release = () => { touching = false; sync(); };
  document.addEventListener('pointerup', release, options);
  document.addEventListener('pointercancel', release, options);
  slider.addEventListener('touchstart', () => { touching = true; sync(); }, { ...options, passive: true });
  slider.addEventListener('touchend', event => { touching = event.touches.length > 0; sync(); }, { ...options, passive: true });
  slider.addEventListener('touchcancel', release, options);
  track.addEventListener('scroll', sync, { ...options, passive: true });
  document.addEventListener('visibilitychange', sync, options);
  mobile.addEventListener('change', sync, options);
  reduced.addEventListener('change', sync, options);
  slider.addEventListener('hk:destroy', () => {
    if (document.hidden && slider.isConnected) { stop(); return; }
    destroyed = true;
    stop();
    observer.disconnect();
    controller.abort();
  }, options);
  slider.addEventListener('hk:start', sync, options);
  sync();
}

    function initializeSlider(slider) {
      if (slider.dataset.hkInitialized === 'true') return;
      if (slider.dataset.layout === 'grid' && slider.dataset.carouselOnMobile === 'true' && slider.dataset.autoplay === 'true' && slider.querySelector('[data-hk-autoplay-toggle]')) {
        slider.dataset.hkInitialized = 'true';
        initializeMobileAutoplay(slider);
        return;
      }

      const track = slider.querySelector('[data-hk-track]');
      const slides = [...slider.querySelectorAll('[data-hk-slide]')];
      const prevButton = slider.querySelector('[data-hk-prev]');
      const nextButton = slider.querySelector('[data-hk-next]');
      const dots = [...slider.querySelectorAll('[data-hk-dot]')];

      if (!track || slides.length === 0) return;

      slider.dataset.hkInitialized = 'true';

      const loop = slider.dataset.loop === 'true';
      const autoplay = slider.dataset.autoplay === 'true';
      const delay = Math.max(Number(slider.dataset.delay) || 5000, 2000);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let timer = null;
      let scrollTimer = null;

      function getStep() {
        if (slides.length < 2) return slides[0]?.getBoundingClientRect().width || 0;
        return Math.abs(slides[1].offsetLeft - slides[0].offsetLeft);
      }

      function getCurrentIndex() {
        const step = getStep();
        if (!step) return 0;
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / step)));
      }

      function isAtStart() {
        return track.scrollLeft <= 2;
      }

      function isAtEnd() {
        return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      function updateControls() {
        const index = getCurrentIndex();

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        if (!loop) {
          if (prevButton) prevButton.disabled = isAtStart();
          if (nextButton) nextButton.disabled = isAtEnd();
        }
      }

      function goTo(index, behavior = 'smooth') {
        const normalized = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({
          left: slides[normalized].offsetLeft,
          behavior
        });
      }

      function goNext() {
        const current = getCurrentIndex();

        if (isAtEnd()) {
          if (loop) goTo(0);
          return;
        }

        goTo(current + 1);
      }

      function goPrev() {
        const current = getCurrentIndex();

        if (isAtStart()) {
          if (loop) goTo(slides.length - 1);
          return;
        }

        goTo(current - 1);
      }

      function stopAutoplay() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function startAutoplay() {
        stopAutoplay();
        if (!autoplay || reducedMotion || slides.length < 2 || document.hidden) return;
        timer = window.setInterval(goNext, delay);
      }

      prevButton?.addEventListener('click', () => {
        goPrev();
        startAutoplay();
      });

      nextButton?.addEventListener('click', () => {
        goNext();
        startAutoplay();
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.hkDot));
          startAutoplay();
        });
      });

      track.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(updateControls, 80);
        },
        { passive: true }
      );

      slider.addEventListener('pointerenter', stopAutoplay);
      slider.addEventListener('pointerleave', startAutoplay);
      slider.addEventListener('focusin', stopAutoplay);
      slider.addEventListener('focusout', startAutoplay);

      slider.addEventListener('hk:destroy', stopAutoplay);
      slider.addEventListener('hk:start', startAutoplay);

      updateControls();
      startAutoplay();
    }

    function initializeAll(root = document) {
      getSliders(root).forEach(initializeSlider);
    }

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      getSliders(event.target).forEach((slider) => {
        slider.dispatchEvent(new CustomEvent('hk:destroy'));
      });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-hk-slide]');
      const slider = event.target.closest(SELECTOR);

      if (slide && slider) {
        slider.dispatchEvent(new CustomEvent('hk:destroy'));
        slide.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    });

    document.addEventListener('visibilitychange', () => {
      document.querySelectorAll(SELECTOR).forEach((slider) => {
        slider.dispatchEvent(
          new CustomEvent(document.hidden ? 'hk:destroy' : 'hk:start')
        );
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
